import { render } from "./IconClose.vue?vue&type=template&id=d10acf3e"
import script from "./IconClose.vue?vue&type=script&lang=ts"
export * from "./IconClose.vue?vue&type=script&lang=ts"
script.render = render

export default script